var _defs, _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimizeNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-122{fill:#caccd0;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 20.39,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 14.68,
    y: 5.06,
    width: 1.5,
    height: 12.77
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "8.57 17.91 2.11 11.45 8.57 4.99 9.63 6.05 4.23 11.45 9.63 16.85 8.57 17.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeNavIcon);
export default __webpack_public_path__ + "static/media/minimize_nav_Icon.464f24e5496a012704bd4d15c8479552.svg";
export { ForwardRef as ReactComponent };